import { BaseModel } from "../shared/base.model";

export class IamRole extends BaseModel {
    public static override stringifyExclude: string[] = [
        "stringifyExclude",
        "registry"
    ];

    public long_role_name: string = "";
    public short_role_desc: string = "";
    public long_role_desc: string = "";

    public constructor() {
        super();
    }

    // This function, when present, is automatically
    // called by the JSON.stringify function.
    public override toJSON() {
        return super.toJSON(IamRole.stringifyExclude);
    }

    public static toIamRoles(obj: string | Object[]): IamRole[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let customers: IamRole[] = [];

        for (const o2 of (<Object[]>obj2)) {
            customers.push(IamRole.toIamRole(o2));
        }

        return customers;
    }

    public static toIamRole(obj: string | Object): IamRole {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of IamRole.
        return Object.assign(new IamRole(), obj2);
    }
}
